export default ($) => {

  const $w = $(window)

  /**
   * Check <img> Orientation relative to the parent element.
   *     If a <img> is vertically long relative to the parent element add class 'is-portrait'.
   */
  window.checkImgOrientation = imgElement => {
    const imgs = imgElement ? [imgElement] : Array.from(document.querySelectorAll('img'));
    imgs.forEach(img => {
      const parentElement = img.parentNode;
      if (img.naturalWidth / img.naturalHeight < parentElement.offsetWidth / parentElement.offsetHeight) {
        img.classList.remove('is-landscape');
        img.classList.add('is-portrait');
      } else {
        img.classList.remove('is-portrait');
        img.classList.add('is-landscape');
      }
    })
  }

  /**
   * Check complete of <img> load.
   *     Add class 'hasImg' to <img>'s parents.
   *     When is complete load of <img>, add class 'is-loaded'.
   */
  window.checkImgComplete = (imgElement) => {
    const imgs = imgElement ? [imgElement] : Array.from(document.querySelectorAll('img'));
    let isCompleteAllImg = false;
    imgs.forEach(img => {
      const parentElement = (img.parentNode);
      parentElement.classList.add('hasImg');
    })
    const loop = () => {
      if (!isCompleteAllImg) {
        let countImgComplete = 0
        imgs.forEach(img => {
          const parentElement = img.parentNode;
          if (img.complete && img.hasAttribute('src')) {
            parentElement.classList.add('is-loaded');
            checkImgOrientation(img);
            countImgComplete++;
          }
        })
        if (countImgComplete === imgs.length) {
          isCompleteAllImg = true;
        } else {
          requestAnimationFrame(loop);
        }
      }
    }
    requestAnimationFrame(loop);
  }

  window.lazyload = () => {
    const imgs = document.querySelectorAll('img');
    const sources = document.querySelectorAll('source');
    const windowScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const placeholderImageUrl = '/assets/img/img_placeholder.png';
    
    imgs.forEach(img => {
      if (((img.hasAttribute('data-src') && (!img.hasAttribute('src') || img.getAttribute('src') == placeholderImageUrl)) || (img.hasAttribute('data-srcset') && !img.hasAttribute('srcset'))) && (windowScrollTop + window.innerHeight ) > window.pageYOffset + img.getBoundingClientRect().top - 200) {
        const parentElement = img.parentNode;
        parentElement.classList.remove('is-loaded');
        if (img.hasAttribute('data-src')) {
          img.setAttribute('src', img.getAttribute('data-src'));
        }
        if (img.hasAttribute('data-srcset')) {
          img.setAttribute('srcset', img.getAttribute('data-srcset'));
        }
        checkImgComplete(img);
      }
    });
    sources.forEach(source => {
      if (source.hasAttribute('data-srcset') && !source.hasAttribute('srcset') && (windowScrollTop + window.innerHeight ) > window.pageYOffset + source.getBoundingClientRect().top) {
        const parentElement = source.parentNode
        parentElement.classList.remove('is-loaded');
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
        checkImgComplete(parentElement.querySelector('img'));
      }
    });
  }

  const checkDevice = () => {
    $('body').append('<div class="windowSize" /><div class="deviseSize" />');
    $('.windowSize').css({
      'position': 'fixed',
      'left': '0',
      'bottom': '0',
      'z-index': '-1',
      'width': '100%'
    });
    $('.deviseSize').css({
      'position': 'fixed',
      'left': '0',
      'bottom': '0',
      'z-index': '-1',
      'width': '100vw'
    });
    if($('.windowSize').outerWidth() !== $('.deviseSize').outerWidth()) {
      $('body').addClass('has-scroll-bar')
    }
    if(window.userAgent.indexOf('iphone') > -1 || window.userAgent.indexOf('ipod') > -1) {
      $('.windowSize').css({
        'bottom': 'auto',
        'top': '0',
        'width': '0',
        'height': '100%'
      });
      $('.deviseSize').css({
        'bottom': 'auto',
        'top': '0',
        'width': '0',
        'height': '100vh'
      });
      if(Math.round($('.windowSize').outerHeight()) !== Math.round($('.deviseSize').outerHeight())) {
        $('body').addClass('is-not-fit-100vh')
      } else {
        $('body').removeClass('is-not-fit-100vh')
      }
    }
    $('.windowSize, .deviseSize').remove()
  }

  $(() => {

    let isIe = false

    if (window.userAgent.indexOf('msie') != -1 || window.userAgent.indexOf('trident') != -1) {
      isIe = true
      $('body').addClass('is-IE')
      if (window.appVersion.indexOf("msie 9.") != -1) {
        $('body').addClass('is-IE9')
      }
    }
  
    if (window.userAgent.indexOf('iphone') != -1 || window.userAgent.indexOf('ipod') != -1) {
      $('body').addClass('is-ios')
    }

    var elm = document.createElement('div')
    window.deviceInfo = {
      css: {
        display: {
          contents: true,
          grid: true
        },
        position: {
          sticky: true
        }
      }
    }
    elm.style.display = isIe ? '-ms-grid' : 'grid'
    if (elm.style.display !== 'grid' && elm.style.display !== '-ms-grid') {
      $('body').addClass('no-css--dispGrid')
      deviceInfo.css.display.grid = false;
    }
    elm.style.display = 'contents'
    if (elm.style.display !== 'contents') {
      $('body').addClass('no-css--dispContents')
      deviceInfo.css.display.contents = false;
    }
    elm.style.position = 'sticky'
    if (elm.style.position !== 'sticky' && userAgent.indexOf('iphone') === -1 && userAgent.indexOf('ipad') === -1) {
      $('body').addClass('no-css--posSticky')
      deviceInfo.css.position.sticky = false;
    }
    elm = null;

    checkDevice();
    lazyload();
    
    $w.on('keydown', e => {
      if (e.key === "Tab") {
        $('body').addClass('is-tabControled')
        $w.off('keydown')
      }
    })

  })

  $w.on('pageshow', () => {
    checkDevice();
    checkImgOrientation();
    checkImgComplete();
  })
  window.addEventListener('scroll', () => {
    lazyload();
  })
  
  /**
   * @type {Boolean} - リサイズイベントに紐付いたイベントがが実行中かどうか
   */
  let isRunning = true
  /**
   * @type {Number} - 前のリサイズイベント時の window の横幅
   */
  let prevWndWidth = $w.width()
  $w.on('resize', e => {
    if (isRunning) {
      isRunning = false
      requestAnimationFrame(function () {
        isRunning = true
        if ($w.width() !== prevWndWidth) {
          prevWndWidth = $w.width();
          checkDevice();
          checkImgOrientation();
        }
      })
    }
  })

}